import graphql__a8af2af1abf56231f369 from "./__generated__/SubscriptionModal_subscribable.graphql.js";import { defineMessages } from "react-intl";
import { createFragmentContainer } from "react-relay";
import { graphql } from "react-relay";
import { connect } from "react-redux";
import { useFormatMessage } from "../Intl/Context";

import { useAlert } from "../Alerts/withAlert";
import { ALERT_TYPE_ERROR, ALERT_TYPE_SUCCESS } from "../Alerts/Alert";
import Modal from "../Modals/Modal";
import withFormStore from "../Form/withFormStore";
import EmailField from "../Form/Field/EmailField";
import Button from "../Buttons/Button";
import { intlMessages as formPageIntlMessages } from "../ParticipativeModule/FormPage";

import { loadViewer } from "../../reducers/viewer";
import { subscribe } from "../../mutations/SubscribeMutation";

const SubscriptionModal = props => {
  const {
    viewer,
    validateForm,
    formState,
    subscribable,
    loadViewer,
    onRequestClose,
    isOpen
  } = props;

  const t = useFormatMessage();
  const labels = {
    title: t(intlMessages.title),
    description: t(intlMessages.description, {
      b: message => `<b>${message}</b>`,
      p: message => `<p>${message}</p>`
    }),
    requiredFieldsHint: t(formPageIntlMessages.requiredFieldsHint),
    email: t(intlMessages.email),
    emailHint: t(intlMessages.emailHint),
    submit: t(intlMessages.submit),
    successMessage: t(intlMessages.successMessage)
  };

  const { showAlert } = useAlert();

  const submitForm = e => {
    // Avoid actual HTML form submission
    if (e && e.preventDefault) {
      e.preventDefault(e);
    }
    if (validateForm()) {
      const { subscriptionEmail } = formState.fields;
      const email = subscriptionEmail && subscriptionEmail.value;
      subscribe(email, subscribable.id, onSubscribeResponse);
    }
  };

  const onSubscribeResponse = response => {
    if (response.subscribe.success) {
      showAlert({
        message: labels.successMessage,
        type: ALERT_TYPE_SUCCESS
      });

      const { subscriptionEmail } = formState.fields;
      if (subscriptionEmail && subscriptionEmail.value) {
        loadViewer();
      }

      onRequestClose();
    } else {
      showAlert({
        message: response.subscribe.notice,
        type: ALERT_TYPE_ERROR
      });
    }
  };

  return (
    <Modal
      onRequestClose={onRequestClose}
      isOpen={isOpen}
      title={labels.title}
      className="modal-with-actions"
    >
      <form onSubmit={submitForm}>
        <div className="box margin-bottom-xs padding-x-lg padding-y-md">
          {!viewer.email && (
            <>
              <p
                className="form-hint-required-fields margin-bottom-sm text-small"
                dangerouslySetInnerHTML={{ __html: labels.requiredFieldsHint }}
              />

              <EmailField
                fieldName="subscriptionEmail"
                label={labels.email}
                hint={labels.emailHint}
                required
                defaultValue={viewer.email}
                autoComplete="email"
              />
            </>
          )}

          <div dangerouslySetInnerHTML={{ __html: labels.description }} />
        </div>

        <div className="modal-actions modal-buttons-container">
          <Button
            type="submit"
            className="btn btn-primary btn-block-md box-shadow-lg"
            label={labels.submit}
            iconClassName="icon-validate"
            iconPosition="after"
          />
        </div>
      </form>
    </Modal>
  );
};

const mapDispatchToProps = dispatch => {
  return {
    loadViewer: () => dispatch(loadViewer())
  };
};

const SubscriptionModalContainer = connect(null, mapDispatchToProps)(SubscriptionModal);

export default createFragmentContainer(withFormStore(SubscriptionModalContainer), {
  subscribable: graphql__a8af2af1abf56231f369
});

const intlMessages = defineMessages({
  title: {
    id: "subscription.title",
    defaultMessage: "S'abonner aux mises à jour de la page"
  },
  description: {
    id: "subscription.description",
    defaultMessage: `
      <p>
        En vous abonnant aux mises à jour de la page, vous serez notifiés lorsque son 
        contenu sera modifié.
      </p>
      <p>
        <b>
          Merci de cliquer sur le bouton ci-dessous afin de confirmer que vous souhaitez 
          bien vous abonner.
        </b>
      </p>
    `
  },
  email: {
    id: "subscription.email",
    defaultMessage: "E-mail"
  },
  emailHint: {
    id: "subscription.emailHint",
    defaultMessage: "Permet de vous notifier lors d'une mise à jour du contenu."
  },
  submit: {
    id: "subscription.submit",
    defaultMessage: "Confirmer mon abonnement"
  },
  successMessage: {
    id: "subscription.success",
    defaultMessage: "Votre abonnement a bien été pris en compte"
  }
});
